export const VERTICAL_IMAGE_RATIO = 5 / 7;

export const HORIZONTAL_IMAGE_RATIO = 6 / 4;
export const HORIZONTAL_IMAGE_RATIO_SM = 6 / 3.76;
export const HORIZONTAL_IMAGE_RATIO_XL = 6 / 3.88;
export const HORIZONTAL_IMAGE_RATIO_1920 = 6 / 3.98;
